import { MeterModelState } from './types';

const state = (): MeterModelState => {
  return {
    meterModels: [],
  };
};

export default state;
